import Model, {toModel, toMoment, toProp} from "./Model";
import Patient from "./Patient";

/**
 *
 * @class User
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.3] app/src/model/User.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */
class User extends Model {
  constructor(modelData) {
    super()

    /** @type string */
    this.id = toProp()

    /** @type Patient|null */
    this.patient = toModel(Patient)

    /** @type number|null */
    this.patientId = toProp()

    /** @type Object */
    this.knowledgeLevel = toProp();

    /** @type string|null */
    this.subjectId = toProp()

    /** @type moment|null */
    this.enrollmentDate = toMoment()

    this.buildModel(modelData)
  }

  getChosenPatientEntry(){
    return {
      text: this.patient.getSearchEntryText(),
      patientId : this.patient.patientId,
      subjectId: this.subjectId
    }
  }
}

export default User;